import { memo, useCallback, useState } from 'react';
import cn from 'classnames';
import { ArrayUtils } from 'src/utils';
import { pushLogAdNative } from 'src/redux/actions/ad';
import {
    Button,
    Element,
    Image,
    Checkbox,
    RouterLink,
    Title,
    IconButton,
} from 'src/components';
import Menu from 'src/components/menu';
import Card from 'src/components/card';

export type CONTENT_REPORT = {
    DEFAULT: 'default';
    HIDE: 'hide';
    DESKTOP: 'desktop';
    TOUCH: 'touch';
    TABLET: 'tablet';
    MOBILE: 'mobile';
};

export interface IReasion {
    id: number;
    text: string;
}

const CHECKBOX_HIDE = [
    {
        id: 12,
        text: 'Nhạy cảm',
    },
    {
        id: 13,
        text: 'Lỗi hiển thị',
    },
    {
        id: 14,
        text: 'Hiện nhiều lần',
    },
    {
        id: 15,
        text: 'Không phù hợp',
    },
    {
        id: 16,
        text: 'Đã mua rồi',
    },
];

const CHECKBOX_REPORT = [
    {
        id: 2,
        text: 'Phản cảm/Bạo lực',
    },
    {
        id: 3,
        text: 'Giả mạo, lừa đảo',
    },
    {
        id: 4,
        text: 'Gây hiểu lầm',
    },
    {
        id: 5,
        text: 'Có nội dung cấm',
    },
    {
        id: 6,
        text: 'Dẫn về trang tin giả',
    },
    {
        id: 7,
        text: 'Spam',
    },
];

const ITEM_OTHER = {
    id: 1,
    text: 'Khác',
};

export default memo(function ModalReport({ hide, onSubmit, item }: any) {
    const [showCheckbox, setShowCheckbox] = useState<boolean>(false);
    const listHideReason = [
        ...ArrayUtils.shuffle(CHECKBOX_HIDE),
        ITEM_OTHER,
    ] as IReasion[];
    const listReportReason = [
        ...ArrayUtils.shuffle(CHECKBOX_REPORT),
        ITEM_OTHER,
    ] as IReasion[];
    const [value, setValue] = useState<number>(0);
    const [fbLanding, setFbLanding] = useState<number>(0);
    const [listReasion, setListReasion] = useState<IReasion[]>([]);
    const { sourceId } = item;

    const handleHideAds = useCallback(
        (listHideReason: any, fbLanding: any) => {
            setShowCheckbox(true);
            setListReasion(listHideReason);
            setFbLanding(fbLanding);
        },
        [showCheckbox, listHideReason],
    );

    const onChange = useCallback((e: any) => {
        setValue(+e.target.name);
    }, []);

    const renderCheckbox = useCallback(() => {
        return (
            <Menu.List className="flex flex-wrap gap-[8px] mt-[12px]">
                {listReasion.map((item) => {
                    const checked = item.id === value;
                    return (
                        <Menu.List.Item className="shrink-0" key={item.id}>
                            <Checkbox
                                classNameCheckbox={'peer/checkbox hidden'}
                                classNameLabel={cn(
                                    'flex items-center justify-center',
                                    'relative',
                                    'text-[14px] leading-[normal]',
                                    'h-[32px]',
                                    'px-[12px]',
                                    'rounded-full',
                                    'bg-white',
                                    'transition-all',
                                    'peer-checked/checkbox:bg-[var(--primary)] peer-checked/checkbox:text-white',
                                )}
                                checked={checked}
                                name={`${item.id}`}
                                onChange={onChange}
                            >
                                {item.text}
                            </Checkbox>
                        </Menu.List.Item>
                    );
                })}
            </Menu.List>
        );
    }, [value, listReasion]);

    const submitReport = useCallback(() => {
        const arrSource = sourceId.split(',');
        const zoneId = arrSource[0];
        const bannerId = arrSource[1];
        const deviceId = arrSource[2];
        const params = {
            bannerId,
            deviceId,
            zoneId,
            useragent: navigator.userAgent,
            fbLanding,
            fbType: value,
        };
        pushLogAdNative(params);
        onSubmit(fbLanding);
        hide();
    }, [sourceId, fbLanding, value]);

    return (
        <Card>
            <Card.Header
                className={cn(
                    'relative',
                    'flex items-center',
                    'px-[16px]',
                    'h-[52px]',
                    'border-b border-solid border-[#E9ECEF]',
                    'rounded-t-[12px]',
                    'bg-[#F8F9FA]',
                )}
            >
                <Title className="text-[20px] font-[800]">
                    Thông tin quảng cáo
                </Title>
                <IconButton
                    onClick={hide}
                    icon="new-x-close-light"
                    className={cn(
                        'absolute top-1/2 right-[8px]',
                        '-translate-y-1/2',
                        'p-[4px]',
                    )}
                    classNameIcon="text-[12px] text-[#131214]"
                />
            </Card.Header>
            <Card.Content className="flex px-[16px] py-[20px]">
                <Image
                    className={cn(
                        'w-[60px] h-[60px]',
                        'shrink-0',
                        'rounded-[4px]',
                        'overflow-hidden',
                        'bg-[#eee]',
                        '[&_img]:object-cover',
                    )}
                    title={`Quảng cáo ${item.title}`}
                    src={item.thumb[0]}
                />
                <Element
                    className={cn(
                        'text-[16px] text-black leading-[1.4] font-[600]',
                        'pl-[12px]',
                        'line-clamp-3',
                        'select-none',
                    )}
                >
                    {item.title}
                </Element>
            </Card.Content>
            <>
                {showCheckbox ? (
                    <>
                        <Card.Footer
                            className={cn(
                                'flex-col',
                                'text-[var(--dark)] text-center font-[600]',
                                'p-[12px_16px_20px] mt-0',
                                'h-auto',
                                'rounded-none',
                                'bg-[#ededed]',
                                '[&>:not(:first-child)]:ml-0',
                            )}
                        >
                            <Element className={'text-[13px] text-[#808080]'}>
                                Vui lòng chia sẻ lý do bạn muốn ẩn quảng cáo này
                            </Element>
                            {renderCheckbox()}
                            <Element
                                className={cn(
                                    'text-[#808080] text-[13px] leading-[1.5] text-left',
                                    'mt-[28px]',
                                    'rounded-[8px]',
                                    'bg-[rgba(0,0,0,0.05)]',
                                    'p-[8px_12px]',
                                )}
                            >
                                Tìm hiểu thêm về
                                <RouterLink
                                    className="font-[900]"
                                    newTab
                                    to="https://ads.zalo.me/business/p/chinh-sach/"
                                >
                                    &nbsp;chính sách quảng cáo&nbsp;
                                </RouterLink>
                                của chúng tôi
                            </Element>
                        </Card.Footer>
                        <Element className={'text-center bg-white px-[32px]'}>
                            <Button
                                className={cn(
                                    'flex items-center justify-center',
                                    'text-[16px] text-white font-[600]',
                                    'w-[150px] h-[44px]',
                                    'my-[8px] mx-auto px-[38px]',
                                    'rounded-[8px]',
                                    'bg-[#2fa1b3]',
                                    'transition-all duration-[0.35s] ease-[ease]',
                                    'disabled:bg-[#f0f0f0] disabled:text-[#999]',
                                )}
                                title="Xác nhận"
                                disabled={value === 0}
                                onClick={submitReport}
                            >
                                Xác nhận
                            </Button>
                        </Element>
                    </>
                ) : (
                    <>
                        <Card.Footer
                            className={cn(
                                'flex-col',
                                'text-[#131214] text-center font-[600]',
                                'p-[12px_16px_20px] mt-0',
                                'h-auto',
                                'rounded-none',
                                'bg-[#ededed]',
                                '[&>:not(:first-child)]:ml-0',
                            )}
                        >
                            <Element className={'text-[13px] text-[#808080]'}>
                                Các thao tác mà bạn có thể thực hiện
                            </Element>
                            <Button
                                title="Ẩn"
                                className={cn(
                                    'flex items-center justify-center',
                                    'h-[40px] w-[90%]',
                                    'text-[16px] font-[600]',
                                    'mt-[10px]',
                                    'rounded-[4px]',
                                    'bg-white',
                                )}
                                onClick={() => handleHideAds(listHideReason, 2)}
                            >
                                Ẩn quảng cáo này
                            </Button>
                            <Button
                                className={cn(
                                    'flex items-center justify-center',
                                    'h-[40px] w-[90%]',
                                    'text-[16px] font-[600]',
                                    'mt-[10px]',
                                    'rounded-[4px]',
                                    'bg-white',
                                )}
                                title="Báo xấu"
                                onClick={() =>
                                    handleHideAds(listReportReason, 3)
                                }
                            >
                                Báo xấu quảng cáo
                            </Button>
                        </Card.Footer>

                        <Element className={'text-center'}>
                            <Element
                                className={
                                    'text-[10px] text-[#B2B2B2] p-[8px_16px]'
                                }
                            >
                                Quảng cáo từ adtima
                            </Element>
                        </Element>
                    </>
                )}
            </>
        </Card>
    );
});
